if (!customElements.get("product-recommendations")) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
    }

    connectedCallback() {
      this.performRecommendations();
    }

    performRecommendations() {
      const recommendations = this.querySelector("[data-recommendations]");
      if (!recommendations) return;
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const recommendationsHTML = new DOMParser()
            .parseFromString(text, "text/html")
            .querySelector("[data-recommendations]")?.innerHTML;
          if (!recommendationsHTML) return;
          this.classList.remove("hidden");
          var cartDrawerItemsFull = document.querySelector(
            ".cart-drawer-items__full"
          );
          if (cartDrawerItemsFull) {
            cartDrawerItemsFull.classList.remove(".cart-drawer-items__full");
          }
          recommendations.innerHTML = recommendationsHTML;
          this.initSlider();

          // initiate quick cart after fetch
          // to activate trigger button events
          setTimeout(() => {
            if (document.querySelector("quick-cart-drawer")) {
              document.querySelector("quick-cart-drawer").init();
            }
          }, 2500);
        });
    }

    initSlider() {
      this.slider = new Swiper(this.querySelector(".swiper"), {
        slidesPerView: "auto",
        spaceBetween: 16,
        autoplay: {
          delay: 5000, // time in milliseconds between slides
          disableOnInteraction: false, // keep autoplay running after user interaction
        },
        loop: false, // optional: allows infinite loop
      });
    }
  }

  customElements.define("product-recommendations", ProductRecommendations);
}
